
let orderIds = []
const MAX_RETRIES = 3;
const TIMEOUT_MS = 5000;

function validateProcess(url, orderId) {
    const form = new FormData();
    form.append("orderId", orderId);
    return fetch(url, {
        body: form,
        method: "POST"
    })
}

async function fetchValidate(url, orderId, retries) {
    await new Promise(resolve => setTimeout(resolve, TIMEOUT_MS));

    const response = await validateProcess(url, orderId);

    if (!response.ok) {
        return;
    }

    const json = await response.json();
    if (!json.Successful && !json.ShowMessage && retries > 0) {
        await fetchValidate(url, orderId, retries - 2);
        return;
    }

    if (!json.Successful) {
        delete orderIds[orderIds.indexOf(orderId)];
        postMessage({
            orderId: orderId,
            userMessage: json.UserMessage,
            successful: false,
            showMessage: false,
            orderStatus: null
        })
        return;
    }

    if (json.ShowMessage) {
        delete orderIds[orderIds.indexOf(orderId)];
        postMessage({
            orderId: orderId,
            successful: json.Successful,
            userMessage: json.UserMessage,
            showMessage: json.ShowMessage,
            orderStatus: json.OrderStatus
        })
        return;
    }
    
    await fetchValidate(url, orderId, retries);
}

onmessage = async function (oEvent) {

    const orderId = oEvent.data.orderId;
    if (orderIds.some(id => id === orderId)) {
        return;
    }
    orderIds.push(orderId);

    await fetchValidate(oEvent.data.url, orderId, MAX_RETRIES);
};
